var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconChevronLeftDouble = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (
    // <IconContainer {...rest}>
    //     <IconSVG color={color} inheritColor={props.inheritColor} fill="none" x="0px" y="0px" viewBox="0 0 30 30" strokeLinejoin="round" strokeLinecap="round">
    //         <path d="M21.5,8.5L15,15l6.5,6.5" />
    //         <path d="M15,8.5L8.5,15l6.5,6.5" />
    //     </IconSVG>
    // </IconContainer >
    React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "miter", strokeLinecap: "square" },
            React.createElement("g", null,
                React.createElement("path", { d: "M21.4,24.9L13.9,15l7.5-9.9" }),
                React.createElement("path", { d: "M16.1,24.9L8.6,15l7.5-9.9" })))));
});
export default IconChevronLeftDouble;
//# sourceMappingURL=IconChevronLeftDouble.js.map